import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Welcome from './Welcome';
import History from './History';
import DS from './DS';
import HeroScene from './HeroScene';



function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' exact element={<HeroScene />}></Route>
          <Route path='/home' exact element={<Welcome />}></Route>
          <Route exact path='/timeline' element = {<History />}></Route>
          <Route path='/ds' exact element = {<DS />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App;
